export default __webpack_public_path__ + "static/media/025-positive thinking.80c5c967.svg";